import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import PopOver from '@bibliocommons/base-accessibility-pop-over';
import { Info as InfoIcon } from '@bibliocommons/base-icons';

import BorrowingQuotas from '../../shared/BorrowingQuotas';

const renderTriggerContent = () => (
  <div>
    <InfoIcon />
    &nbsp;
    <FormattedMessage id="holds_see_limits" />
  </div>
);

export default function HoldsQuotasPopOver({ quotas }) {
  if (!quotas || quotas.size === 0) {
    return null;
  }

  return (
    <span className="cp-holds-quotas-pop-over">
      <PopOver
        href="#holds-quotas-pop-over"
        triggerContent={renderTriggerContent()}>
        <BorrowingQuotas
          title={<FormattedMessage id="holds_my_limits" />}
          quotas={quotas} />
      </PopOver>
    </span>
  );
}


HoldsQuotasPopOver.propTypes = {
  quotas: ImmutablePropTypes.list
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsQuotasPopOver/HoldsQuotasPopOver.jsx